/* eslint react-hooks/exhaustive-deps: "warn" */
import styles from './MsvTicker.module.scss';

const REGISTRIES = [
  { flag: '🇬🇧', name: 'UK Companies House' },
  { flag: '🇸🇪', name: 'SE Bolagsverket' },
  { flag: '🇩🇪', name: 'DE Handelsregister' },
  { flag: '🇵🇱', name: 'PL KRS' },
  { flag: '🇫🇷', name: 'FR Infogreffe' },
  { flag: '🇳🇱', name: 'NL KvK' },
  { flag: '🇪🇸', name: 'ES Registro Mercantil' },
  { flag: '🇧🇷', name: 'BR Receita Federal CNPJ' },
  { flag: '🇦🇺', name: 'AU ASIC' },
  { flag: '🇪🇪', name: 'EE e-Business Register' },
  { flag: '🇹🇷', name: 'TR Ticaret Sicili' },
  { flag: '🇳🇴', name: 'NO Brønnøysund' },
];

export const MsvTicker = () => (
  <div className={styles.root}>
    <div className={styles.track}>
      {[...REGISTRIES, ...REGISTRIES].map((r, i) => (
        <div key={i} className={styles.item}>
          <span className={styles.flag}>{r.flag}</span>
          <span>{r.name}</span>
        </div>
      ))}
    </div>
  </div>
);
